import { Container } from "react-bootstrap";

export default function ({ className = "py-5 py-md-6", content, theme = "light" }) {
  return (
    <div className={className} data-bs-theme={theme}>
      <Container fluid="md" className="mw-xl">
        <div className="mb-5 content" dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </div>
  );
}
